// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1vVMB","content":"GlobalSearch_content__3vRo7"};